export default __webpack_public_path__ + "static/media/982.6aa66cff.png";